import { gql } from '@apollo/client/index.js'

export const ALL_NINETAILED_FEATURE_FLAGS_QUERY = gql`
  fragment ninetailedFeatureFlagFrag on NtFeatureFlag {
    __typename
    sys {
      id
    }
    title
    json
  }

  fragment ninetailedFeatureFlagExp on NtExperience {
    sys {
      id
    }
    __typename
    ntName
    ntType
    ntAudience {
      sys {
        id
      }
      ntName
    }
    ntConfig
    ntVariantsCollection(limit: 20) {
      items {
        ... on NtFeatureFlag {
          ...ninetailedFeatureFlagFrag
        }
      }
    }
  }

  query AllNinetailedQuery(
    $preview: Boolean!
    $locale: String!
  ) {
    ntFeatureFlagCollection(
      preview: $preview,
      locale: $locale,
      where: {
        nt_experiencesCollection_exists: true,
        json_exists: true      # json was null in one of the entries
      }
    ) {
      items {
        ...ninetailedFeatureFlagFrag
        ntExperiencesCollection(limit: 20) {
          items {
            ...ninetailedFeatureFlagExp
          }
        }
      }
    }
  }
`
